import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between mb-4" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "space-y-2" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "mt-4 flex justify-end" }
const _hoisted_7 = ["disabled"]

import { ref, computed, watch, inject } from 'vue'
import { useTheme } from '../../../utils/useTheme'
import type { AuditLogsFilters } from '../../../types/audit-logs'

// Use theme via inject with a fallback
interface Props {
  filters: AuditLogsFilters
  resourceTypes?: string[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AuditLogsFilters',
  props: {
    filters: {},
    resourceTypes: { default: () => [] }
  },
  emits: ["update:filters", "apply-filters"],
  setup(__props: any, { emit: __emit }) {

const theme = inject('theme', useTheme())

const props = __props

const emit = __emit

// Local filters state
const localFilters = ref<AuditLogsFilters>({ ...props.filters })

// Available HTTP methods
const httpMethods = ['GET', 'POST', 'PUT', 'DELETE', 'PATCH']

// Check if there are changes
const hasChanges = computed(() => {
  return JSON.stringify(localFilters.value) !== JSON.stringify(props.filters)
})

// Watch for external filter changes
watch(
  () => props.filters,
  (newFilters) => {
    localFilters.value = { ...newFilters }
  },
  { deep: true }
)

// Methods
const applyFilters = () => {
  emit('update:filters', { ...localFilters.value })
  emit('apply-filters', { ...localFilters.value })
}

const clearFilters = () => {
  localFilters.value = {
    resourceType: '',
    resourceId: '',
    userId: '',
    startDate: '',
    endDate: '',
    httpMethod: []
  }
  applyFilters()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
      'rounded-lg border p-4 shadow-sm'
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", {
        class: _normalizeClass([
          _unref(theme).isDark.value ? 'text-gray-200' : 'text-gray-900',
          'text-lg font-medium'
        ])
      }, " Filters ", 2),
      _createElementVNode("button", {
        onClick: clearFilters,
        class: _normalizeClass([
          _unref(theme).isDark.value
            ? 'text-gray-400 hover:text-gray-200'
            : 'text-gray-500 hover:text-gray-700',
          'text-sm font-medium'
        ])
      }, " Clear All ", 2)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("label", {
          for: "resource-type",
          class: _normalizeClass([
            _unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-700',
            'block text-sm font-medium mb-1'
          ])
        }, " Resource Type ", 2),
        _withDirectives(_createElementVNode("select", {
          id: "resource-type",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localFilters.value.resourceType) = $event)),
          class: _normalizeClass([
            _unref(theme).isDark.value
              ? 'bg-gray-700 border-gray-600 text-gray-200'
              : 'bg-white border-gray-300 text-gray-700',
            'w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500'
          ])
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("option", { value: "" }, "All Types", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resourceTypes, (type) => {
            return (_openBlock(), _createElementBlock("option", {
              key: type,
              value: type
            }, _toDisplayString(type), 9, _hoisted_3))
          }), 128))
        ], 2), [
          [_vModelSelect, localFilters.value.resourceType]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", {
          for: "resource-id",
          class: _normalizeClass([
            _unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-700',
            'block text-sm font-medium mb-1'
          ])
        }, " Resource ID ", 2),
        _withDirectives(_createElementVNode("input", {
          id: "resource-id",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localFilters.value.resourceId) = $event)),
          type: "text",
          placeholder: "Enter resource ID...",
          class: _normalizeClass([
            _unref(theme).isDark.value
              ? 'bg-gray-700 border-gray-600 text-gray-200'
              : 'bg-white border-gray-300 text-gray-700',
            'w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500'
          ])
        }, null, 2), [
          [_vModelText, localFilters.value.resourceId]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", {
          for: "user-id",
          class: _normalizeClass([
            _unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-700',
            'block text-sm font-medium mb-1'
          ])
        }, " User ID ", 2),
        _withDirectives(_createElementVNode("input", {
          id: "user-id",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localFilters.value.userId) = $event)),
          type: "text",
          placeholder: "Enter user ID...",
          class: _normalizeClass([
            _unref(theme).isDark.value
              ? 'bg-gray-700 border-gray-600 text-gray-200'
              : 'bg-white border-gray-300 text-gray-700',
            'w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500'
          ])
        }, null, 2), [
          [_vModelText, localFilters.value.userId]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", {
          for: "start-date",
          class: _normalizeClass([
            _unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-700',
            'block text-sm font-medium mb-1'
          ])
        }, " Start Date ", 2),
        _withDirectives(_createElementVNode("input", {
          id: "start-date",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localFilters.value.startDate) = $event)),
          type: "datetime-local",
          class: _normalizeClass([
            _unref(theme).isDark.value
              ? 'bg-gray-700 border-gray-600 text-gray-200'
              : 'bg-white border-gray-300 text-gray-700',
            'w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500'
          ])
        }, null, 2), [
          [_vModelText, localFilters.value.startDate]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", {
          for: "end-date",
          class: _normalizeClass([
            _unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-700',
            'block text-sm font-medium mb-1'
          ])
        }, " End Date ", 2),
        _withDirectives(_createElementVNode("input", {
          id: "end-date",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localFilters.value.endDate) = $event)),
          type: "datetime-local",
          class: _normalizeClass([
            _unref(theme).isDark.value
              ? 'bg-gray-700 border-gray-600 text-gray-200'
              : 'bg-white border-gray-300 text-gray-700',
            'w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500'
          ])
        }, null, 2), [
          [_vModelText, localFilters.value.endDate]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("fieldset", null, [
          _createElementVNode("legend", {
            class: _normalizeClass([
              _unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-700',
              'block text-sm font-medium mb-1'
            ])
          }, " HTTP Method ", 2),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(httpMethods, (method) => {
              return _createElementVNode("label", {
                key: method,
                class: _normalizeClass([
                _unref(theme).isDark.value ? 'text-gray-300' : 'text-gray-700',
                'flex items-center space-x-2 text-sm'
              ])
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((localFilters.value.httpMethod) = $event)),
                  type: "checkbox",
                  value: method,
                  class: _normalizeClass([
                  _unref(theme).isDark.value
                    ? 'bg-gray-700 border-gray-600 text-blue-500'
                    : 'bg-white border-gray-300 text-blue-500',
                  'rounded focus:ring-blue-500'
                ])
                }, null, 10, _hoisted_5), [
                  [_vModelCheckbox, localFilters.value.httpMethod]
                ]),
                _createElementVNode("span", null, _toDisplayString(method), 1)
              ], 2)
            }), 64))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        onClick: applyFilters,
        disabled: !hasChanges.value,
        class: _normalizeClass([
          hasChanges.value
            ? _unref(theme).isDark.value
              ? 'bg-blue-600 hover:bg-blue-700 text-white'
              : 'bg-blue-600 hover:bg-blue-700 text-white'
            : _unref(theme).isDark.value
              ? 'bg-gray-700 text-gray-400 cursor-not-allowed'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed',
          'px-4 py-2 rounded-md text-sm font-medium transition-colors'
        ])
      }, " Apply Filters ", 10, _hoisted_7)
    ])
  ], 2))
}
}

})